import { css } from '@emotion/react';

export const innerContainerStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
`;
